import { type HexaString } from "@ledgerhq/device-management-kit";

export enum WETHSupportedChainIds {
  ETHEREUM_MAINNET = 1,
  ETHEREUM_GOERLI = 5,
  ETHEREUM_SEPOLIA = 11155111,
  ARBITRUM_ONE = 42161,
  ARBITRUM_GOERLI = 421613,
  AVALANCHE_C_CHAIN = 43114,
  BSC = 56,
  BASE = 8453,
  BASE_GOERLI = 84531,
  BLAST = 23888,
  OPTIMISM = 10,
  OPTIMISM_GOERLI = 420,
  POLYGON = 137,
  POLYGON_MUMBAI = 80001,
}

export type WETHSupportedChainId = keyof typeof WETH_ADDRESS_BY_CHAIN_ID;

export const WETH_ADDRESS_BY_CHAIN_ID: Record<
  WETHSupportedChainIds,
  HexaString
> = {
  [WETHSupportedChainIds.ETHEREUM_MAINNET]:
    "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
  [WETHSupportedChainIds.ETHEREUM_GOERLI]:
    "0xB4FBF271143F4FBf7B91A5ded31805e42b2208d6",
  [WETHSupportedChainIds.ETHEREUM_SEPOLIA]:
    "0xfFf9976782d46CC05630D1f6eBAb18b2324d6B14",
  [WETHSupportedChainIds.ARBITRUM_ONE]:
    "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
  [WETHSupportedChainIds.ARBITRUM_GOERLI]:
    "0xe39Ab88f8A4777030A534146A9Ca3B52bd5D43A3",
  [WETHSupportedChainIds.AVALANCHE_C_CHAIN]:
    "0xB31f66AA3C1e785363F0875A1B74E27b85FD66c7",
  [WETHSupportedChainIds.BSC]: "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
  [WETHSupportedChainIds.BASE]: "0x4200000000000000000000000000000000000006",
  [WETHSupportedChainIds.BASE_GOERLI]:
    "0x44D627f900da8AdaC7561bD73aA745F132450798",
  [WETHSupportedChainIds.BLAST]: "0x4300000000000000000000000000000000000004",
  [WETHSupportedChainIds.OPTIMISM]:
    "0x4200000000000000000000000000000000000006",
  [WETHSupportedChainIds.OPTIMISM_GOERLI]:
    "0x4200000000000000000000000000000000000006",
  [WETHSupportedChainIds.POLYGON]: "0x0d500B1d8E8eF31E21C99d1Db9A6444d3ADf1270",
  [WETHSupportedChainIds.POLYGON_MUMBAI]:
    "0x9c3C9283D3e44854697Cd22D3Faa240Cfb032889",
};
